import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { statsLeadersNavSelector } from 'store/modules/statspro/stats-leaders/selectors/nav-selector';
import { changeSeason } from 'common/store/modules/statspro/thunks/change-season';

export const SeasonNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(statsLeadersNavSelector);
    const seasons = nav?.seasons;
    const selectedItemToString = (item) => item?.name.split(' ')[0];

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                items={seasons}
                itemToString={(season) => season?.name}
                icon="season-trophy"
                type="with-default"
                selectedItemToString={selectedItemToString}
                initialSelectedItem={
                    seasons?.length && nav.season.id
                        ? seasons.find((s) => s.id === nav.season.id)
                        : ''
                }
                activeItem={
                    seasons?.length && nav.season.id
                        ? seasons.find(
                              (s) =>
                                  s.id.toString() === nav.season.id.toString()
                          )
                        : ''
                }
                isReadyToRender={() => seasons?.length && nav.season.id}
                label={getTranslation('label.statsLeaders.nav.season')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        changeSeason({
                            slice: 'stats-leaders',
                            season: selectedItem,
                            round: {
                                id: -1
                            }
                        })
                    );
                }}
            />
        </div>
    );
};
